import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import moment from 'moment';
import NpsService from '../../../services/resource/npsService';
import BranchService from '../../../services/resource/branchService';
import NpsTabelaPorDia from './NpsTabelaPorDia';
import NpsPorMotorista from './NpsPorMotorista';
import MotoristaService from '../../../services/resource/motoristaService';
import MotoristasSemNps from './MotoristasSemNps';
import { reduceName } from '../../../utils/reduceName';
import NpsPorAjudante from './NpsPorAjudante';

const DashboardNps = () => {
  const driverService = new MotoristaService();
  const [resumo, setResumo] = useState({});
  const [porDia, setPorDia] = useState([]);
  const [npsPorMotorista, setNpsPorMotorista] = useState([]);
  const [motoristaSemNps, setMotoristaSemNps] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [driversAssistants, setDriverAssistants] = useState([]);
  const [evolucao, setEvolucao] = useState([]);
  const [criterios, setCriterios] = useState([]);
  const [branchId, setBranchId] = useState('');
  const [filiais, setFiliais] = useState([]);
  const [driverId, setDriverId] = useState('');
  const [branches, setBranches] = useState([]);
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))
  const [loading, setLoading] = useState(false);
  const [loadingResumo, setLoadingResumo] = useState(false);

  useEffect(() => {
    // Exemplo com BranchService
    new BranchService().findAll().then(res => setBranches(res.data));
  }, []);

  useEffect(() => {
    if (branchId) {
      driverService.findAllByBranch(branchId).then(response => setDrivers(response.data))
    } else {
      if (driverId) {
        setDriverId(null);
      }
      setDrivers([]);
    }
  }, [branchId]);

  useEffect(() => {
    setLoading(true);
    setLoadingResumo(true);
    const service = new NpsService();

    const params = { startDate, endDate };
    if (branchId) params.branchId = branchId;
    if (driverId) params.driverId = driverId;

    service.getPorDia(params).then(res => {
      setPorDia(res.data);
      // Coletar todas as chaves únicas de filial
      const todasFiliais = new Set();
      res.data.forEach(item => {
        Object.keys(item.porFilial).forEach(filial => todasFiliais.add(filial));
      });
      setFiliais([...todasFiliais].sort());
    })

    service.getDashboard(params).then(res => setResumo(res.data)).finally(setLoadingResumo(false));
    service.getEvolucao(params).then(res => setEvolucao(res.data));
    service.getMediaPorCriterio(params).then(res => setCriterios(res.data));
    service.getPorMotorista(params).then(res => setNpsPorMotorista(res.data));
    service.getMotoristasSemNps(params).then(res => setMotoristaSemNps(res.data));
    service.getPorAjudante(params).then(res => setDriverAssistants(res.data));

    setTimeout(() => {
      setLoading(false)
    }, 2000);
  }, [startDate, endDate, branchId, driverId]);
  console.log(startDate, endDate, ' BRANCH:' + branchId, " Driver: " + driverId)
    ;
  return (
    <div className="w-full p-6 space-y-6">
      <div className="lg:flex sm:flex-wrap justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-700">Dashboard NPS</h2>
        <div className='flex flex-wrap gap gap-2'>
          <select
            className="border px-3 py-1 rounded text-sm "
            value={branchId}
            onChange={e => setBranchId(e.target.value)}
          >
            <option value="">Todas as filiais</option>
            {branches.map(branch => (
              <option key={branch.id} value={branch.id}>
                {branch.name}
              </option>
            ))}
          </select>
          <select
            className="border px-3 py-1 rounded text-sm"
            value={driverId}
            onChange={e => setDriverId(e.target.value)}
          >
            <option value="">Todos Motoristas</option>
            {drivers.map(driver => (
              <option key={driver.id} value={driver.id}>
                {driver.id} - {reduceName(driver.name)}
              </option>
            ))}
          </select>
          <input type='date' className='border px-3 py-1 rounded text-sm' name='startDate' value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          <input type='date' className='border px-3 py-1 rounded text-sm' name='endDate' value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </div>
      </div>

      {loading ? (
        <div className="text-center py-10">
          <i className="fas fa-spinner fa-spin text-4xl text-indigo-600 mb-4" />
          <p className="text-gray-600">Carregando Dashboard...</p>
        </div>
      ) : porDia.length === 0 ? (
        <div className="text-center py-10 h-100">
          <i className="fas fa-inbox text-4xl text-gray-400 mb-4" />
          <p className="text-gray-600">Não existem dados para exibição com os parâmetros informados.</p>
        </div>
      ) : (
        <div className='space-y-6 fade-in'>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <ResumoCard title="Promotores" value={resumo.totalPromoters} percent={resumo.promotersPercent} color="green" icon="fa-smile" />
            <ResumoCard title="Neutros" value={resumo.totalNeutrals} percent={resumo.neutralsPercent} color="yellow" icon="fa-meh" />
            <ResumoCard title="Detratores" value={resumo.totalDetractors} percent={resumo.detractorsPercent} color="red" icon="fa-frown" />
            <ResumoCard title="Pontuação NPS" value={resumo.npsScore} percent={null} color="blue" icon="fa-star" />
          </div>

          <div className="flex grid-cols-1 md:grid-cols-2 gap-6">
            <div className="col-md-6 bg-white p-4 rounded shadow">
              <h3 className="font-semibold text-gray-700 mb-2">Evolução do NPS</h3>
              {evolucao.length && !loading > 0 &&
                <Chart
                  options={{
                    chart: { type: 'line', width:'100%' },
                    xaxis: { categories: evolucao.map(e => e.mes) },
                    stroke: { curve: 'smooth' },
                    dataLabels: { enabled: false },
                    colors: ['#3b82f6'],
                  }}
                  series={[{ name: 'NPS', data: evolucao.map(e => e.valor) }]}
                  type="line"
                  height={300}
                  max-width={500}
              
                />
              }
            </div>

            <div className="col-md-6 bg-white p-4 rounded shadow">
              <h3 className="font-semibold text-gray-700 mb-2">Distribuição de Respostas</h3>
              {!loadingResumo &&
                <Chart
                  options={{
                    labels: ['Promotores', 'Neutros', 'Detratores'],
                    colors: ['#10b981', '#fbbf24', '#ef4444'],
                    legend: { position: 'bottom' }
                  }}
                  series={[resumo.totalPromoters, resumo.totalNeutrals, resumo.totalDetractors]}
                  type="donut"
                  width="100%"
                  height={300}
                />
              }
            </div>
          </div>

          <div className="bg-white p-4 rounded shadow">
            <h3 className="font-semibold text-gray-700 mb-2">Avaliação por Critério</h3>
            {criterios.length && !loading > 0 &&
              <Chart
                options={{
                  chart: { type: 'bar' },
                  xaxis: { categories: criterios.map(c => c.nome) },
                  dataLabels: { enabled: true },
                  plotOptions: { bar: { horizontal: false } },
                  yaxis: { max: 3, title: { text: 'Média (0 a 3)' } },
                  colors: ['#4548e7ff']
                }}
                series={[{ name: 'Avaliação', data: criterios.map(c => c.media) }]}
                type="bar"
                height={300}
              />
            }
          </div>
          <NpsTabelaPorDia filiais={filiais} dados={porDia} />
          <NpsPorMotorista dados={npsPorMotorista} />
          <MotoristasSemNps dados={motoristaSemNps} />
          <NpsPorAjudante dados={driversAssistants} />
        </div>
      )}
    </div>
  );
};

const ResumoCard = ({ title, value, percent, color, icon }) => (
  <div className="bg-white rounded-lg shadow p-4">
    <div className="flex items-center">
      <div className={`p-3 rounded-full bg-${color}-100 text-${color}-600`}>
        <i className={`fas ${icon}`}></i>
      </div>
      <div className="ml-4">
        <p className="text-sm font-medium text-gray-500">{title}</p>
        <p className="text-2xl font-bold">{value}</p>
      </div>
    </div>
    {percent !== null && (
      <div className="mt-2 text-sm text-gray-500">
        {percent ? percent.toFixed(1) : 0.00}% do total
      </div>
    )}
  </div>
);

export default DashboardNps;
